module.exports = __webpack_public_path__ + "static/media/Mail_Message_Default@3x.18b62f1d.png";